/**
 * Returns the source object for a vector layer
 * @param {string} mapboxId - Mapbox id of the layer
 * @param {string} sourceId - Id of the source
 * @returns {Object} - Source object
 */
export function vectorSource(mapboxId, sourceId) {
  return {
    type: "vector",
    id: sourceId,
    url: `mapbox://fzj.${mapboxId}`,
  };
}

/**
 * Returns the source object for a raster layer
 * @param {string} mapboxId - Mapbox id of the layer
 * @returns {Object} - Source object
 */
export function rasterSource(mapboxId) {
  return {
    type: "raster",
    id: mapboxId,
    tiles: [`https://api.mapbox.com/v4/fzj.${mapboxId}/{z}/{x}/{y}.png`],
  };
}

/**
 * Returns the source object for an emergency raster layer
 * @param {string} mapboxId - Mapbox id of the layer
 * @returns {Object} - Source object
 */
export function emergencyRasterSource(mapboxId) {
  return {
    type: "raster",
    id: mapboxId,
    tiles: [`https://api.mapbox.com/v4/fzj.${mapboxId}/{z}/{x}/{y}.png`],
    tileSize: 512,
  };
}
